module.exports = __webpack_public_path__ + "fonts/qvest-regular.svg";